import { render } from "./PopupImage.vue?vue&type=template&id=d8911f2e&scoped=true"
import script from "./PopupImage.vue?vue&type=script&lang=js"
export * from "./PopupImage.vue?vue&type=script&lang=js"

import "./PopupImage.vue?vue&type=style&index=0&id=d8911f2e&scoped=true&lang=scss"
import "./PopupImage.vue?vue&type=style&index=1&id=d8911f2e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8911f2e"]])

export default __exports__